import LTVCalculators from '/src/services/LTVCalculators';
import RQSABudget from '/src/services/QuollScore/RQSABudget';
import RQSAOpex from '/src/services/QuollScore/RQSAOpex';
export default function RunQuollScoreAnalysis(propertyData, userPersonalInfo, geoData, housingMarketData) {

    if (!propertyData || !userPersonalInfo || !geoData || !housingMarketData) {
        return null;
    }
 
    // console.log('Inputs to RunQuollScoreAnalysis:', { propertyData, userPersonalInfo, geoData, housingMarketData });

    // Run the RQSABudget function
    const budgetAnalysis = RQSABudget(propertyData, userPersonalInfo, geoData);
    const budgetScore = budgetAnalysis?.budgetRiskLevel
    // console.log('Budget Analysis', budgetAnalysis);

    // Run the RQSAOpex function
    const opexAnalysis = RQSAOpex(propertyData, userPersonalInfo, geoData);
    const opexScore = opexAnalysis?.opexRiskLevel
    // console.log('Opex Analysis', opexAnalysis);

    // Get the LTV scores for attractiveness and market signals plus the combined score
    const ltvScoring = housingMarketData?.ltvScoring;
    const ltvAttractivenessScore = ltvScoring?.attractivenessScore;
    const ltvMarketSignalsScore = ltvScoring?.marketSignalsScore;
    const ltvCombinedScore = ltvScoring?.combinedRiskLevelScore;

    // Get the average of the three scores
    const quollScore = Math.round((budgetScore + opexScore + ltvCombinedScore) / 3);
    // console.log('Quoll Score Details: ', { budgetScore, opexScore, ltvCombinedScore, quollScore });

    let quollScoreLetter = "C";
    if (quollScore >= 8) {
        quollScoreLetter = "F";
    } else if (quollScore >= 6) {
        quollScoreLetter = "D";
    } else if (quollScore >= 4) {
        quollScoreLetter = "C";
    } else if (quollScore >= 2) {
        quollScoreLetter = "B";
    } else {
        quollScoreLetter = "A";
    }

    // Creat the Quoll Score object with the three scores and quollScore
    const quollScoreObject = {
        budgetScore: budgetScore,
        opexScore: opexScore,
        ltvCombinedScore: ltvCombinedScore,
        quollScore: quollScore,
        quollScoreLetter: quollScoreLetter
    }
    // Create the output
    const outputObject = {
        quollScore: quollScoreObject,
        budget: budgetAnalysis,
        opex: opexAnalysis,
        ltv: ltvScoring,
    }
    // console.log('Output Object', outputObject);


    return outputObject;
}   
